import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
   
    
}
const mutations={
   
    
    getAttrData(state,value){
        
        
     
        post(urls.admin.attr.index,value).then((result)=>{
          console.log(result)  
          state.result=result
         
        
        });
        
    },
    addAttrData(state,value){
        
     
     
        post(urls.admin.attr.add,value).then((result)=>{
          console.log(result)  
          state.result=result
        
        
        });
        
    },
    editAttrData(state,value){
       
     
        post(urls.admin.attr.edit,value).then((result)=>{
          console.log(result)  
          state.result=result
        
        
        });
        
    },
    deleteAttr(state,value){


        post(urls.admin.attr.delete,value).then((result)=>{

            state.result=result


        });

    }

}
const  actions={
    getAttrDataAction(context,value){
       
        context.commit("getAttrData",value)
       
    },
    addAttrDataAction(context,value){
       
        context.commit("addAttrData",value)
       
    },
    editAttrDataAction(context,value){
       
        context.commit("editAttrData",value)
       
    },
    deleteAttrAction(context,value){

        context.commit("deleteAttr",value)

    },

    
   

}

export default {state,mutations,actions}